import Utils from "@/utils/Utils"
import store from "@/store"
import AxiosManager from '@/utils/AxiosManager'
import Constants from '@/helpers/Constants'

/**
 * A broker class to handle the Backend calls
 */
export default class BackendBroker {

  /**
   * Get records
   *
   * @param component Component name <String>
   * @param args GET request argument
   *
   * @returns Axios request result <Array<any>>
   */
  public static async get(component: string, args: any = {}) {
    let url = `/get?comp=${component}`

    // Add the request arguments if any
    if (args !== undefined) {
      Object.keys(args).forEach((key: string) => {
        url +=  '&' + key + '=' + args[key]
      });
    }
    const axiosManager = new AxiosManager(Constants.SERVER_URL)
    const res = await axiosManager.get(url)
    return res
  }


  /**
   * Add a new record
   *
   * @param component Component name <String>
   * @param payload Add request params
   *
   * @returns Axios request result <Array<any>>
  */
  public static async add(component: string, payload: any = {}) {
    const url = `/add`
    payload = {
      ...payload,
      comp: component,
    }
    const axiosManager = new AxiosManager(Constants.SERVER_URL)
    const res = await axiosManager.post(url, payload)
    return res
  }


  /**
   * Update record
   *
   * @param component Component name <String>
   * @param payload Update request params
   *
  * @returns Axios request result <Array<any>>
    */
  public static async update(component: string, payload: any = {}) {
    const url = `/update`
    payload = {
      ...payload,
      comp: component,
    }
    const axiosManager = new AxiosManager(Constants.SERVER_URL)
    const res = await axiosManager.put(url, payload)
    return res
  }


  /**
   * Delete record
   *
   * @param component Component name <String>
   * @param args DELETE request argument
   *
   * @returns Axios request result
   */
  public static async delete(component: string, id: number) {
    let url = `/delete?comp=${component}`
    const axiosManager = new AxiosManager(Constants.SERVER_URL)
    const res = await axiosManager.delete(url, id)
    return res
  }


  /**
   * Save the audit settings
   *
   * @param component Component name <String>
   * @param payload audit settings
   *
   * @returns Axios request result
  */
  public static async saveAuditSettings(component: string, payload: any = {}) {
    const url = `/set_audit_setting`
    payload = {
      ...payload,
      comp: component,
    }
    const axiosManager = new AxiosManager(Constants.SERVER_URL)
    const res = await axiosManager.post(url, payload)
    return res
  }


  /**
   * Perform the tariff calculations and generate the invoice
   *
   * @param component Component name <String>
   *
   * @returns Axios request result
  */
  public static async performTariffCalculations(component: string, payload: any = {}) {
    const url = `/generate_invoice`
    payload = {
      ...payload,
      comp: component,
    }
    const axiosManager = new AxiosManager(Constants.SERVER_URL)
    const res = await axiosManager.post(url, payload)
    return res
  }


  /**
   * Get the tariff formula-set status (Option C):
   * { read_only, version, checksum, count }
   *
   * @returns Axios request result
   */
  public static async getFormulaSetStatus() {
    const url = `/formula_set_status`
    const axiosManager = new AxiosManager(Constants.SERVER_URL)
    const res = await axiosManager.get(url)
    return res
  }


  /**
   * Get the MDA heartbeat data
   *
   * @param component Component name <String>
   *
   * @returns Axios request result
  */
  public static async getMdaHeartbeat(payload: any = {}) {
    const url = `/get_mda_heartbeat`
    payload = {
      ...payload,
      comp: 'mda',
    }
    const axiosManager = new AxiosManager(Constants.SERVER_URL)
    const res = await axiosManager.get(url, payload)
    return res
  }

}
